export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  category: string;
  tags: string[];
  views: number;
  likes: number;
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "《流浪地球3》票房破40亿，中国科幻电影迎来黄金时代",
    summary: "《流浪地球3》自上映以来一路高歌猛进，票房突破40亿大关，标志着中国科幻电影工业化迈入新阶段。影片在视觉效果、故事深度和演员表现上均获好评。",
    content: `<p>《流浪地球3》自上映以来，票房一路高歌猛进，目前已突破40亿人民币，成为中国影史票房榜上的又一力作。这部由郭帆执导的科幻巨制，不仅在国内市场取得了巨大成功，在海外市场的表现同样亮眼。</p>
    
    <h2>中国科幻电影的里程碑</h2>
    <p>从《流浪地球》第一部开始，中国科幻电影就开始了一场从无到有的蜕变。第三部的成功，标志着中国科幻电影已经具备了与国际顶尖制作比肩的实力。影片中的视觉效果由国内团队主导完成，行星发动机、太空电梯、月球碎片等场景的呈现令人叹为观止。</p>
    
    <h2>故事深度再升级</h2>
    <p>与前两部相比，《流浪地球3》在故事层面有了更深入的探索。影片不仅关注人类在面对末日危机时的团结与勇气，更深入探讨了人工智能与人类命运的哲学命题。吴京、刘德华、李雪健等演员的表演也达到了新的高度。</p>
    
    <h2>产业影响深远</h2>
    <p>《流浪地球》系列的成功，带动了整个中国科幻电影产业的发展。越来越多的投资进入科幻领域，更多优秀的科幻IP正在被改编成电影。可以说，中国科幻电影正在迎来属于自己的黄金时代。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20premiere%20event%20with%20red%20carpet%20and%20fans%2C%20cinema%20box%20office%20poster%20display%2C%20celebratory%20atmosphere%2C%20journalistic%20photography%20style%2C%20warm%20golden%20lighting&width=800&height=400&seq=article-1&orientation=landscape",
    author: "影视观察员",
    publishDate: "2026-07-28",
    category: "industry",
    tags: ["科幻", "票房", "流浪地球"],
    views: 56800,
    likes: 2340,
  },
  {
    id: "article-2",
    title: "2026暑期档前瞻：这些大片你不能错过",
    summary: "暑期档即将来临，多部国产大片蓄势待发。从奇幻巨制到现实主义佳作，本文将为你盘点今年暑期最值得期待的十部影片。",
    content: `<p>随着气温逐渐升高，2026年电影暑期档的大幕也即将拉开。今年的暑期档可谓强片云集，国产与进口大片交相辉映。让我们一起来看看有哪些不容错过的精彩影片。</p>
    
    <h2>国产巨制阵容强大</h2>
    <p>今年暑期档的国产片阵容堪称豪华。《封神第二部》将继续讲述殷商与西岐的大战，《哪吒之魔童闹海》将以全新故事回归大银幕。此外，多部现实主义题材影片也将在暑期档亮相，类型涵盖了悬疑、喜剧、青春等多种元素。</p>
    
    <h2>进口大片强势来袭</h2>
    <p>好莱坞方面，多部超级英雄电影和动画大片也将在暑期档与国内观众见面。这些影片在海外市场已经取得了不俗的口碑和票房成绩。</p>
    
    <h2>暑期档观影指南</h2>
    <p>对于影迷来说，合理安排观影计划非常重要。建议优先选择IMAX或杜比影院观看视觉特效大片，以获得最佳的观影体验。此外，部分影院推出的暑期观影卡也是不错的选择。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Summer%20movie%20theater%20lobby%20with%20colorful%20film%20posters%20and%20popcorn%2C%20bright%20and%20energetic%20atmosphere%2C%20cinema%20interior%20photography%2C%20warm%20lighting%20with%20vibrant%20poster%20colors&width=800&height=400&seq=article-2&orientation=landscape",
    author: "电影达人",
    publishDate: "2026-07-25",
    category: "guide",
    tags: ["暑期档", "观影指南", "新片推荐"],
    views: 42100,
    likes: 1876,
  },
  {
    id: "article-3",
    title: "深度解析：《繁花》中的上海记忆与时代变迁",
    summary: "王家卫执导的《繁花》不仅是一部商战剧，更是一部关于上海的城市记忆。本文从多个角度解读剧中呈现的时代变迁与人文情怀。",
    content: `<p>《繁花》自播出以来，引发了广泛的社会讨论。王家卫导演用他标志性的影像语言，将九十年代上海的繁华与喧嚣呈现在观众面前。这部剧不仅仅是一个关于商战的故事，更是一部关于城市、关于时代、关于人性的史诗。</p>
    
    <h2>视觉语言中的上海</h2>
    <p>王家卫的镜头下的上海，是霓虹闪烁的黄河路，是弄堂深处的烟火气，是和平饭店里的觥筹交错。每一帧画面都经过精心构图，色彩浓郁而富有质感，营造出一种既真实又梦幻的观感。</p>
    
    <h2>人物群像与社会缩影</h2>
    <p>阿宝、玲子、汪小姐、李李……《繁花》中的每个角色都不是孤立的个体，而是那个时代不同阶层、不同追求的人群的缩影。他们的命运交织在一起，构成了一幅生动的社会画卷。</p>
    
    <h2>时代精神的回响</h2>
    <p>九十年代是中国改革开放的关键时期，《繁花》准确地捕捉到了那个时代的精神气质——机遇与风险并存，梦想与现实交织。这种时代精神在今天依然有着强烈的共鸣。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20Nanjing%20Road%20at%20night%20with%20neon%20signs%20and%20crowds%2C%20retro%20Chinese%20cityscape%2C%20nostalgic%20atmosphere%2C%20vintage%20photography%20style%2C%20warm%20golden%20and%20red%20neon%20tones&width=800&height=400&seq=article-3&orientation=landscape",
    author: "剧评人小王",
    publishDate: "2026-07-20",
    category: "review",
    tags: ["繁花", "王家卫", "剧评"],
    views: 38900,
    likes: 2105,
  },
  {
    id: "article-4",
    title: "从《鬼灭之刃》到《葬送的芙莉莲》：日本动画的叙事革新",
    summary: "近年来的日本动画在叙事方式上出现了显著的变革，从热血战斗到温情治愈，新一代动画作品正在重新定义这一媒介的表达边界。",
    content: `<p>日本动画产业在过去几年中经历了深刻的变革。从《鬼灭之刃》创下票房神话，到《葬送的芙莉莲》以慢节奏叙事获得口碑丰收，我们看到了日本动画在叙事方式上的多元化探索。</p>
    
    <h2>热血之外的叙事可能</h2>
    <p>长期以来，少年热血漫改动画是日本动画市场的绝对主流。但近年来，像《葬送的芙莉莲》这样以情感和哲思为核心的作品，证明了慢节奏、注重角色内心刻画的叙事同样能获得广泛认可。</p>
    
    <h2>制作水准的整体提升</h2>
    <p>随着制作技术的进步和制作预算的增加，日本动画的画面质量整体提升。无论是《鬼灭之刃》中的战斗场面，还是《芙莉莲》中的风景描绘，都达到了电影级别的制作水准。</p>
    
    <h2>全球化视野下的日本动画</h2>
    <p>流媒体平台的普及让日本动画获得了前所未有的全球受众。这也反过来影响了日本动画的创作方向，更多具有跨文化共鸣的主题和故事被呈现出来。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20anime%20studio%20workspace%20with%20animation%20cells%20and%20drawing%20table%2C%20creative%20atmosphere%2C%20warm%20desk%20lamp%20lighting%2C%20artistic%20photography%20style%2C%20organized%20and%20inspiring&width=800&height=400&seq=article-4&orientation=landscape",
    author: "动漫评论家",
    publishDate: "2026-07-18",
    category: "review",
    tags: ["日本动画", "叙事革新", "芙莉莲"],
    views: 31200,
    likes: 1567,
  },
  {
    id: "article-5",
    title: "综艺节目的新趋势：从《种地吧》看真实感综艺的崛起",
    summary: "以《种地吧》为代表的真实感综艺正在改变中国综艺市场的格局。这类节目抛弃了传统综艺的剧本化操作，用真诚和真实赢得观众。",
    content: `<p>在过去的几年里，中国综艺市场经历了从"大制作大明星"到"真实感小切口"的转变。《种地吧》的火爆，正是这一趋势的最佳注脚。</p>
    
    <h2>真实的力量</h2>
    <p>《种地吧》没有华丽的舞台，没有顶流明星，有的只是十位年轻人脚踏实地的农耕生活。正是这种不加修饰的真实，打动了无数观众。从播种到收获，观众与嘉宾一起经历了190天的劳作历程，产生了强烈的情感连接。</p>
    
    <h2>慢综艺的价值回归</h2>
    <p>在快节奏的都市生活中，人们越来越渴望看到慢下来的生活。《种地吧》提供的不仅是娱乐，更是一种生活方式的展示和思考。在田间地头的劳作中，蕴含着对生命、对自然的敬畏。</p>
    
    <h2>综艺的社会价值</h2>
    <p>优秀的综艺节目不仅要有娱乐性，更要有社会价值。《种地吧》让更多人关注到农业和农村，也启发年轻人思考劳动的意义。这种社会责任感，是综艺节目未来发展的重要方向。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20rural%20farmland%20with%20golden%20wheat%20fields%20and%20farmers%20working%2C%20beautiful%20sunset%20lighting%2C%20peaceful%20%20countryside%20photography%2C%20warm%20golden%20and%20green%20tones&width=800&height=400&seq=article-5&orientation=landscape",
    author: "综艺观察",
    publishDate: "2026-07-15",
    category: "industry",
    tags: ["综艺", "种地吧", "真实感"],
    views: 28600,
    likes: 1342,
  },
  {
    id: "article-6",
    title: "《哪吒之魔童闹海》导演饺子专访：用动画讲好中国故事",
    summary: "《哪吒之魔童闹海》导演饺子接受本网专访，分享了影片的创作历程、对中国动画产业的思考以及未来的创作计划。",
    content: `<p>从《哪吒之魔童降世》到《哪吒之魔童闹海》，饺子导演用两部作品证明了中国动画电影的无限可能。在《魔童闹海》热映之际，我们专访了饺子导演，听他聊聊创作背后的故事。</p>
    
    <h2>创作的初心</h2>
    <p>"我始终相信，好的故事是动画电影的核心，"饺子导演说，"技术和画面是服务于故事的。在做《魔童闹海》的时候，我们花了大量时间打磨剧本，确保每个角色都有完整的人物弧光。"</p>
    
    <h2>中国动画的工业化</h2>
    <p>谈到中国动画产业的现状，饺子导演表示乐观："这几年中国动画的进步是有目共睹的。从人才储备到制作流程，我们正在建立一套完整的工业体系。《哪吒》系列的成功，是团队上千人共同努力的结果。"</p>
    
    <h2>未来展望</h2>
    <p>关于未来的创作计划，饺子导演透露正在筹备新的项目，将继续深耕中国传统文化的现代演绎。"中国有太多好的故事等着被讲述，我希望能够一部一部地把它们呈现给观众。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Animation%20director%20working%20in%20studio%20with%20storyboards%20on%20wall%2C%20creative%20workspace%20with%20warm%20lighting%2C%20professional%20portrait%20photography%20style%2C%20focused%20and%20passionate%20atmosphere&width=800&height=400&seq=article-6&orientation=landscape",
    author: "特约记者",
    publishDate: "2026-07-10",
    category: "interview",
    tags: ["哪吒", "专访", "动画"],
    views: 45300,
    likes: 2890,
  },
];